import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import { FairTopSetting, UpdateFairTopSettingPayload } from './models';

const fairTopSettingService = {
  update(data: FairTopSetting[]): Promise<CommonResponse<null>> {
    const payload: UpdateFairTopSettingPayload[] = [];
    // compose payload form data
    data.forEach((item, index) => {
      const { menu_fair_top_setting_id, dest1_genre_subgenre_id, dest2_genre_subgenre_id } = item;
      payload.push({
        menu_fair_top_setting_id,
        sort_order: index + 1,
        dest1_genre_subgenre_id,
        dest2_genre_subgenre_id,
      });
    });
    const url = `/menu-fair-top-settings`;
    return axiosClient.patch(url, payload);
  },
  getAll(date: Date): Promise<CommonResponse<FairTopSetting[]>> {
    const url = `/menu-fair-top-settings?date=${moment(date).format(DATE_HYPHEN_FORMAT)}`;
    return axiosClient.get(url);
  },
};

export default fairTopSettingService;
